import stringifyAttributes from './stringifyAttributes';

function getRegexForPlaceholders(placeHolderReplacements) {
    const keys = Object.keys(placeHolderReplacements).join('|');

    return RegExp(`{(${keys})}`, 'g');
}

function replacePlaceholders(text, placeHolderReplacements) {
    if (Object.keys(placeHolderReplacements).length === 0) {
        return text;
    }

    const regexPlaceHolders = getRegexForPlaceholders(placeHolderReplacements);

    return text.replace(regexPlaceHolders, (fullMatch, subMatch) => {
        return placeHolderReplacements[subMatch];
    });
}

function populateAttributes(text, htmlAttributes) {
    if (Object.keys(htmlAttributes).length === 0) {
        return text;
    }

    const joinedHtmlAttributes = stringifyAttributes(htmlAttributes);

    const regexMatchFirstHtmlTag = /<([a-z\b]+).*?>.*?<\/\1>/i;

    return text.replace(regexMatchFirstHtmlTag, (tagFull, tagName) => {
        return tagFull.replace(tagName, `${tagName} ${joinedHtmlAttributes}`);
    });
}

function replaceDataAndAttributes(
    text = '',
    placeHolderReplacements = {},
    htmlAttributes = {}
) {
    const completedText = replacePlaceholders(text, placeHolderReplacements);
    return populateAttributes(completedText, htmlAttributes);
}

export default replaceDataAndAttributes;
